import React, { useContext, useState } from "react";
import {
  Button,
  ButtonGroup,
  Icon,
  IconSettings,
  PageHeader,
  PageHeaderControl,
} from "@salesforce/design-system-react";

import RelatedItem from "./RelatedItem";

import { MessagesContext } from "../context/messagesContext";

const RelatedSection = ({ obj }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { pages, displaySalesforceNew } = useContext(MessagesContext);

  const currentPage = pages[pages.length - 1];

  const toggleOpen = () => {
    console.log("toggle open");
  };

  const renderItems = obj.items.map((item, index) => {
    return <RelatedItem item={item} key={index} />;
  });

  const actions = () => (
    <PageHeaderControl>
      <ButtonGroup variant="list" id="button-group-page-header-actions">
        <Button
          label="New"
          onClick={() => displaySalesforceNew(obj.type, currentPage.record)}
        />
        {/* <Button
					assistiveText={{ icon: 'Toggle' }}
					iconCategory="utility"
					iconName="down"
					iconSize="large"
					iconVariant="border-filled"
					onClick={() => toggleOpen()}
					variant="icon"
				/> */}
      </ButtonGroup>
    </PageHeaderControl>
  );

  return (
    <IconSettings iconPath="/icons">
      <PageHeader
        onRenderActions={actions}
        title={obj.title}
        truncate
        variant="related-list"
      />
      <article className="related-section-body">{renderItems}</article>
    </IconSettings>
  );
};

export default RelatedSection;
